import { render, staticRenderFns } from "./Options.vue?vue&type=template&id=25f05060&scoped=true&"
var script = {}
import style0 from "./Options.vue?vue&type=style&index=0&id=25f05060&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f05060",
  null
  
)

export default component.exports